import React from "react";

const ArrowTrendingDown = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-arrow-trending-down"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-arrow-trending-down"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M23,8c-.553,0-1,.447-1,1v5.586l-6.563-6.562c-1.344-1.344-3.531-1.344-4.875,0l-2.577,2.577c-.543,.543-1.428,.543-1.971,0L1.707,6.293c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l4.308,4.308c1.322,1.322,3.477,1.322,4.799,0l2.577-2.577c.564-.564,1.482-.564,2.047,0l6.562,6.562h-5.586c-.553,0-1,.447-1,1s.447,1,1,1h6c1.654,0,3-1.346,3-3v-6c0-.553-.447-1-1-1Z" />
    </svg>
  );
};

export default ArrowTrendingDown;
